import {
    Component,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'app-withdrawal-history-page',
    template: `
        <section class="overlay" style="whidth=100%">
            <div>
                <app-withdrawal-history [showCloseButton]="false"></app-withdrawal-history>
            </div>
        </section>
    `,
    encapsulation: ViewEncapsulation.None,
})
export class WithdrawalHistoryPageComponent {
}
